<dx-scroll-view [height]="height">
  <div class="px-4">
    <dx-toolbar class="fuel-toolbar">
      <dxi-item location="before"
                widget="dxButton"
                locateInMenu="never">
        <div *dxTemplate>
          <div class="toolbar-title">Consommation Carburant</div>
        </div>
      </dxi-item>
      <dxi-item
        widget="dxButton"
        location="after"
        [options]="{
              icon: 'refresh',
              text: 'Réinitialiser',
              type: 'normal',
              hint: 'Réinitialiser',
              onClick: resetChart
          }">
      </dxi-item>
    </dx-toolbar>
  </div>
  <div class="py-2" style="padding: 10px">
    <dx-chart
      id="fuel-chart"
      palette="Bright"
      [dataSource]="ds">
      <!--<dxo-title text="Consommation Carburant"></dxo-title>-->

      <dxo-zoom-and-pan
        [dragToZoom]="true"
        valueAxis="none"
        argumentAxis="both"
      ></dxo-zoom-and-pan>

      <dxi-series argumentField="time" valueField="value"></dxi-series>

      <dxo-argument-axis argumentType="datetime"></dxo-argument-axis>
      <dxo-value-axis>
        <dxo-label [customizeText]="valueAxisAddUnit"></dxo-label>
      </dxo-value-axis>


      <dxo-size height="350" [width]="width"></dxo-size>

      <!--    <dxo-common-series-settings width="2">
            <dxo-hover-style width="2"></dxo-hover-style>
          </dxo-common-series-settings>-->

      <dxo-legend [visible]="false"></dxo-legend>

      <dxo-common-axis-settings>
        <dxo-grid [visible]="true"></dxo-grid>
      </dxo-common-axis-settings>


      <!--<dxo-scroll-bar [visible]="scrollVisible"></dxo-scroll-bar>-->

      <dxo-export [enabled]="true"></dxo-export>

      <dxo-tooltip contentTemplate="historyChartTooltip" [zIndex]="300000" argumentFormat="shortDateShortTime"
                   [enabled]="true"></dxo-tooltip>
      <div *dxTemplate="let info of 'historyChartTooltip'">
        <div>{{info.value.toFixed(2)}} L - {{info.argumentText}}</div>
      </div>
    </dx-chart>
  </div>

  <div class="py-4">
    <dx-data-grid
      id="fuel-filling-details"
      class="fuel-filling-details"
      [dataSource]="fillingDs"
      [showRowLines]="true"
      [rowAlternationEnabled]="false"
      [hoverStateEnabled]="true"
      [columnAutoWidth]="true"
      [libGridTitle]="{text: 'Remplissages'}"
      [showBorders]="false">

      <dxi-column
        caption="Date"
        dataType="date"
        format="shortDateShortTime"
        dataField="time">
      </dxi-column>

      <dxi-column
        caption="Litres"
        format="#0.## L"
        dataField="diff">
      </dxi-column>
    </dx-data-grid>
  </div>
</dx-scroll-view>
<dx-load-panel
  shadingColor="rgba(0,0,0,0.05)"
  [position]="{of: host.nativeElement}"
  [visible]="isLoading"
  [showIndicator]="true"
  [showPane]="false"
  [shading]="true"
  [closeOnOutsideClick]="false">
</dx-load-panel>
